export const updateLsArray = (location: string, values: string[]) => {
  if (values.length > 0) {
    window.localStorage.setItem(location, values.join(','))
  } else {
    window.localStorage.removeItem(location)
  }
}
